/* eslint-disable no-bitwise */
import * as React from "react";
import { getActiveMapVariant, getUnitSize } from "../../../map/variants";

type Position = "left" | "right" | "top" | "bottom";

interface WDOrderTypeButtonProps {
  province: string;
  unitSlotName: string;
  position: Position;
  text: string;
  clickHandler: () => void;
}

const WDFlyoutButton: React.FC<WDOrderTypeButtonProps> = function ({
  province,
  unitSlotName,
  position,
  text,
  clickHandler,
}): React.ReactElement {
  const { provincesMapData } = getActiveMapVariant();
  const provinceMapData = provincesMapData[province];
  if (!provinceMapData || !provinceMapData.unitSlotsBySlotName[unitSlotName])
    return <div />;

  const unitX =
    provinceMapData.x + provinceMapData.unitSlotsBySlotName[unitSlotName].x;
  const unitY =
    provinceMapData.y + provinceMapData.unitSlotsBySlotName[unitSlotName].y;

  // 按钮大小跟随棋子的 unitSize，保证任何地图上按钮与棋子体量相当，
  // 不会再出现小棋子旁边挂着巨大按钮的情况。
  const unitSize = getUnitSize();
  const fontSize = Math.max(10, Math.round(unitSize * 0.3));
  const rh = Math.round(fontSize * 1.9);
  const rw = Math.round(fontSize * 0.9 + text.length * fontSize * 1.02);
  const rBorder = rh / 2;
  const rFill = "rgba(0,0,0,.7)";
  const groupStyle: React.CSSProperties = {
    cursor: "pointer",
  };
  let shiftX = 0;
  let shiftY = 0;
  const shiftOffset = Math.round(unitSize * 0.75);
  if (position === "top") {
    shiftY = -(rh / 2 + shiftOffset);
  } else if (position === "bottom") {
    shiftY = +(rh / 2 + shiftOffset);
  } else if (position === "left") {
    shiftX = -(rw / 2 + shiftOffset);
  } else if (position === "right") {
    shiftX = +(rw / 2 + shiftOffset);
  } else {
    throw Error(position);
  }
  const svgX = unitX - rw / 2 + shiftX;
  const svgY = unitY - rh / 2 + shiftY;

  /*
   * r is the circle radius
  cx and cy are offsets
  rx and ry and rounded edges
   */
  return (
    <svg
      x={svgX}
      y={svgY}
      filter={`drop-shadow(${Math.round(unitSize * 0.08)}px ${Math.round(
        unitSize * 0.08,
      )}px ${Math.round(unitSize * 0.16)}px #222222)`}
      onClick={clickHandler}
    >
      <g style={groupStyle}>
        <rect
          x={0}
          y={0}
          fill="white"
          width={rw}
          height={rh}
          rx={rBorder}
          ry={rBorder}
        />
        <text
          x={rw / 2}
          y={rh / 2}
          textAnchor="middle"
          alignmentBaseline="middle"
          fontFamily="Roboto"
          fontSize={fontSize}
          style={{
            userSelect: "none",
          }}
          fill="black"
        >
          {text}
        </text>
      </g>
    </svg>
  );
};

export default WDFlyoutButton;
